import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";
import { useCookieConsentOptional } from "../context/CookieConsentContext";

const DEBOUNCE_MS = 2500;

/**
 * Siempre reporta la visita.
 * Con analítica: servidor guarda IP.
 * Sin analítica: solo agregados anónimos (sin IP).
 */
export default function VisitTracker() {
  const location = useLocation();
  const consent = useCookieConsentOptional();
  const lastKey = useRef("");
  const lastAt = useRef(0);

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    // Esperar decisión del banner para no mezclar: si aún no decidió, cuenta como anónimo
    const analyticsOn = Boolean(consent?.analyticsAllowed);

    const key = `${location.pathname}${location.search}:${analyticsOn ? "c" : "a"}`;
    const now = Date.now();
    if (key === lastKey.current && now - lastAt.current < DEBOUNCE_MS) return;
    lastKey.current = key;
    lastAt.current = now;

    const track = httpsCallable(functions, "trackWebsiteVisit");
    track({
      path: location.pathname || "/",
      analyticsConsent: analyticsOn,
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    }).catch(() => {
      /* silencioso */
    });
  }, [location.pathname, location.search, consent?.analyticsAllowed, consent?.decided]);

  return null;
}
